import clientSettingsQuery from 'my-phorest/components/clients/overview/client-settings.graphql';
import { getClientOverviewValidationSchema } from 'my-phorest/components/clients/overview/validation';

// Taken from app/components/clients/overview/index.js - to be shared with search code

// Utility function to fetch client settings
export async function fetchClientSettings(apollo, isNewClient) {
  let business = await apollo.query(
    {
      query: clientSettingsQuery,
    },
    'business'
  );

  let validationSchema = getClientOverviewValidationSchema(
    business.clientSettings,
    {},
    isNewClient
  );

  return {
    clientSettings: business.clientSettings,
    validationSchema,
  };
}

export function createEmptyClientUtility(
  clientSettings,
  clientSearch,
  session
) {
  let { searchProperties } = clientSearch;
  let isAustralianSalon = session.business.locale.countryCode === 'AU';

  let data = {
    ...searchProperties,
    hasChanges: clientSearch.isSearchPropertiesPresent,

    address: { country: {} },

    marketingEmailOptout: isAustralianSalon
      ? clientSettings.defaultEmailMarketingOptOut
      : true,
    marketingSmsOptout: isAustralianSalon
      ? clientSettings.defaultSmsMarketingOptOut
      : true,
    treatCard: {
      serial: null,
      matrixDisabled: false,
    },
  };
  return data;
}
